<template>
    <div id="app" :class="[isImmerse && 'has-top']"
         :style="{'opacity': !pageLoading ? 1 : 0,'background':thisPage=='blank'?'#fff':''}">
        <!-- 顶部分享按钮 -->

        <div class="top" v-if="isImmerse" :style="{'top': statusBarHeight+'px'}">
            <button class="back-btn" @click="back"></button>
            <button class="share-btn" @click="share"></button>
        </div>

        <!--        <div class="music" :style="{'top': statusBarHeight+'px'}">-->
        <!--            <button class="music-btn" :class="!musicFlag && 'off'" @touchstart="switchMusic"></button>-->
        <!--            <audio id="music" autoplay :data-play="musicFlag" loop="loop" src="http://7xte9b.com2.z0.glb.qiniucdn.com/o_1du49c1ptuc41eq11ji68rcjge9.mp3"></audio>-->
        <!--        </div>-->
        <!--        <base-component :baseData="baseData" v-if="baseData"></base-component>-->

        <div>
            <transition enter-active-class="animated fadeInUpBig" leave-active-class="animated fadeOutDownBig ">

                <div class="detailPop" v-show="isToastShow">
                    <div class="popWrapper">
                        <div class="contentPopCls">
                            <div class="topsOperate">
                                <div class="popName">{{toastContent.list.name}}</div>
                                <div class="close" @click="onCloseToast"><img src="./assets/img/close.png"
                                                                              alt="关闭" class="closeImg"></div>
                            </div>
                            <div class="contentTips">
                                <div class="popGlobalText" v-html="toastContent.list.content" v-if="toastContent.toastType==0"> {{toastContent.list.content}}</div>
                                <SelectButton v-if="toastContent.toastType==1" :list="tourSelectData"
                                              @on-select="oTourSelect"/>
                                <ScenicSpot v-if="toastContent.toastType==2" :list="tourSelectData"
                                            @on-select="oTourSelect"/>
                                <NearbyPoint v-if="toastContent.toastType==5" :list="toastContent.list.content"
                                             point-type="food"/>
                                <NearbyPoint v-if="toastContent.toastType==6" :list="toastContent.list.content"
                                             point-type="scenery"/>
                                <NewsInfo v-if="toastContent.toastType==7"/>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <div class="maskWarp" :style="`display:${maskShowStatus?'block':'none'}`"></div>

        <keep-alive :include="cacheList">
            <router-view :style="{'padding-top': statusBarHeight+'px'}"/>
        </keep-alive>

    </div>
</template>

<script>
    import WX from "wechat-js-sdk";
    import COVERAPP from "@/utils/COVERAPP";
    import COVER from "@/utils/COVER";
    import {userLog} from "@/api/data";
    import {getLocationPoint} from "@/utils/utils";
    import SelectButton from "@/components/Use/selectButton";
    import ScenicSpot from "@/components/Use/scenic-spot";
    import NearbyPoint from "@/components/Use/nearby-point";
    import NewsInfo from '@/components/Use/news-info'
    import {mapState, mapActions, mapMutations} from "vuex";

    export default {
        data() {
            return {
                musicFlag: true,
                baseData: null,
                statusBarHeight: 0,
                thisPage: "home",
                show: false,
                formPage: "",
                path: "home",
                oContent: {},
                timeCount: 0,
                timer: null,
                cacheList: ["home"]
            };
        },
        computed: {
            ...mapState(["isApp", "versionSize", "userinfo", "pageLoading", "shareData", "isImmerse", "maskData", "globalDuration", "isClearTimer", "toastContent", "isToastShow", "readNewsId", "isClearInitTimer", "maskShowStatus", "tourSelectData"])
        },
        components: {SelectButton, ScenicSpot, NearbyPoint,NewsInfo},
        watch: {
            // globalDuration(value) {
            //     if (value == 0) {
            //         this.timeCount = 0;
            //         this.timer = setInterval(this.inter, 1000);
            //     }
            // },

            isClearTimer(value) {
                console.info("isClearTimer", value);
                if (value) {
                    clearInterval(this.timer);
                } else {
                    this.timeCount = 0;
                    this.timer = setInterval(this.inter, 1000);
                }
            },

            "$route"(to, from) {

                this.thisPage = to.name;
                this.formPage = from.name;
                let referrer = document.referrer;
                console.info("referrer", referrer);
                if (from.name == "blank" && to.name == "home") {

                }
                // if(referrer!==''&&from.name!=='blank'&&!this.isClearInitTimer){
                //     this.getInterData(0)
                // }
                if (this.formPage == null) {
                    // this.$router.replace('/')
                }
                this.setPageLoadingAsync(true);
                // document.querySelector('.loading-wrap').style.display = 'block'

                // if(this.maskData && this.maskData.type != 1 && this.maskData.type != 2 && this.maskData.type != 3) {
                //     this.setMaskDataAsync(null)
                // }
            }

        },
        created() {

        },
        mounted() {
            this.path = this.$route.name;
            this.appFlagAsync(COVERAPP.Attribute.isApp());
            // this.getInterData()
            let _this = this;
            let isFromSecondFloor = false;
            // cio.initLoad({activeId: "", applicationId: "coverzxrobot"});
            (function(para) {
                var p = para.sdkUrl, n = para.name, w = window, d = document,a=para.activeId,ap=para.applicationId, s = 'script',x = null,y = null;;
                w[n] = w[n] || function(a) {return function() {(w[n]._q = w[n]._q || []).push([a, arguments]);}};
                if (!w[n]._t) {
                    x = d.createElement(s), y = d.getElementsByTagName(s)[0];
                    x.async = 1;
                    x.src = p+'?aid='+a+'&appid='+ap;
                    w[n].para = para;
                    y.parentNode.insertBefore(x, y);
                }
            })({
                sdkUrl: 'https://dcdn.thecover.cn/cio/cover-track-cio.js',
                name: 'cio',
                activeId: "",
                applicationId: "coverzxrobot"
            });

            this.getUserInfoAsync();
            // !this.isApp && COVER.isWapHidden()

            if (this.isApp) {
                let version = COVERAPP.Attribute.appVersion();
                let versionNum = version.split(".");
                let versionSize = parseInt(versionNum.join(""));
                this.setVersionSizeAsync(versionSize);
                if (this.versionSize >= 570) {
                    COVERAPP.Method.getWebInfo({
                        callback(ret) {
                            let data = typeof ret == "object".toLowerCase() ? JSON.stringify(ret) : ret;
                            if (JSON.parse(data).showType == 1) {
                                _this.setIsImmerseAsync(true);
                                let statusBarHeight = JSON.parse(data).statusBarHeight;
                                if (COVERAPP.Attribute.isAndroid()) {
                                    let devicePixelRatio = (typeof window.devicePixelRatio).toLowerCase() == "number" ? window.devicePixelRatio : 0;
                                    _this.statusBarHeight = devicePixelRatio ? statusBarHeight / devicePixelRatio : statusBarHeight;
                                } else {
                                    _this.statusBarHeight = statusBarHeight;
                                }
                            }
                            if (JSON.parse(data).isFromSecondFloor == 1) {
                                isFromSecondFloor = true;
                                COVERAPP.Method.webContentLoadFinish();
                            }
                        }
                    });
                }
            }
            // _this.onWatch();
            _this.setPageLoadingAsync(false);
            clearTimeout(timeoutIds);

        },
        destroyed() {
            clearInterval(this.timer);
        },
        methods: {
            ...mapActions([
                "setPageLoadingAsync",
                "setIsImmerseAsync",
                "appFlagAsync",
                "setVersionSizeAsync",
                "setMaskDataAsync",
                "getUserInfoAsync",
                "getHotTopic", "queryComment", "setNoInfo", "getTourData"
            ]),
            ...mapMutations([
                "contactDisData", "setGlobalDuration", "setToastShow", "setClearTimer", "setInputBlur", "setTagsList", "setTourSelectData", "setSingleTags"
            ]),
            getInterData(time) {
                let that = this;
                this.initTimer = setTimeout(function () {
                    that.setNoInfo();
                }, time);
            },
            onWatch() {
                let that = this;
                that.timeCount = 0;
                that.timer = setInterval(that.inter, 1000);
            },

            inter() {
                let that = this;
                window.addEventListener("touchstart", function () {
                    that.timeCount = 0;
                    that.setGlobalDuration(0);
                }, false);
                that.timeCount++;
                if (that.timeCount > 10) {
                     that.getHotTopic();
                    clearInterval(that.timer);
                    that.timeCount = 0;
                    that.setGlobalDuration(11);
                }
            },


            onBack() {

                if (this.thisPage != "home") {
                    this.$router.back(-1);
                } else {
                    COVERAPP.Method.Back();
                }
            },
            musicPlay() {
                let _this = this;
                let music = document.getElementById("music");
                if (this.musicFlag) {
                    music.play();
                }
                // 微信自动播放
                document.addEventListener("WeixinJSBridgeReady", () => {
                    if (this.musicFlag) {
                        music.play();
                    }
                }, false);
                // 兼容其他不自动播放的情况
                document.addEventListener("touchstart", () => {
                    if (this.musicFlag && this.thisPage == "home") {
                        music.play();
                    }
                }, false);
            },
            switchMusic(e) {
                let music = document.getElementById("music");
                this.musicFlag && e.stopPropagation();
                this.musicFlag = !this.musicFlag;
                if (this.musicFlag) {
                    music.play();
                } else {
                    music.pause();
                }
            },
            back() {

                if (this.formPage == null || this.thisPage != "home") {
                    this.$router.back(-1);
                } else {
                    COVERAPP.Method.Back();
                }
            },
            share() {
                let _this = this;
                let ShareData = JSON.parse(JSON.stringify(this.shareData));
                ShareData.callback = function (ret) {
                    // COVER.track(_this.aid, 'share', '分享')
                    cio.track(1, "share", {});
                };
                if (!this.isImmerse) {
                    COVER.share(ShareData);
                }
            },
            onCloseToast() {
                const {toastType} = this.toastContent;

                if (toastType == 1 || toastType == 2) {
                    this.getTourData({payload: {}});
                }
                if(toastType===7){
                    this.setClearTimer(true);
                    this.contactDisData([{content: {right: true, tips: ""}}]);
                    this.queryComment({payload: {newsId: this.readNewsId}});
                }
                this.setToastShow(false);
            },
            oTourSelect(name, value, id, type, child, select) {
                console.info("select", !!select);
                const {selectType} = this.toastContent;
                let array = [];
                if (selectType == "single") {
                    this.tourSelectData.map((item, ix) => {
                        if (item.name === name && !item.select) {
                            item.select = true;
                            array.push(item);
                        } else {
                            item.select = false;
                            array.push(item);
                        }
                    });
                    this.setSingleTags([{name: name, value: value, select: !!select}]);
                } else {

                    this.tourSelectData.map((item, ix) => {
                        if (item.name === name && !item.select) {
                            item.select = true;
                            array.push(item);
                        } else if (item.name === name && item.select) {
                            item.select = false;
                            array.push(item);
                        } else {
                            array.push(item);
                        }
                    });
                    this.setTagsList([{name: name, value: value, select: !!select}]);

                }

                this.setTourSelectData(array);


            }
        }
    };
</script>

<style lang="less">
    .maskWarp {
        position: fixed;
        left: 0;
        top: 0;
        background: rgba(255, 255, 255, 0);
        width: 100%;
        height: 100%;
        z-index: 1000;
    }

    .detailPop {
        font-size: .24rem;
        position: fixed;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: rgba(0, 0, 0, .5);
        z-index: 1000;
        /*display: none;*/

        .popWrapper {
            max-width: 100%;
            min-width: 100%;
            position: absolute;
            left: 0;
            bottom: 0;
            z-index: 10001;


        }

        .popGlobalText {
            color: rgba(100, 103, 114, 1);
            font-size: .4rem;
            line-height: .7rem;
            .emoji{
                width: .6rem;
                height: .6rem;
            }
        }

        .contentPopCls {
            padding: 1.3rem .4rem 1rem .4rem;
            border-radius: .5rem .5rem 0 0;
            position: relative;
            background: #fff;
        }

        .contentTips {
            font-size: .44rem;
             min-width: 6rem;
            line-height: .7rem;

            max-height: 11rem;
            overflow-y: scroll;

        }

        .topsOperate {
            height: 1.4rem;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            padding: 0 .5rem;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .popName {
                font-size: .45rem;
                color: #171E32;
            }

        }

        .close {

            .closeImg {
                width: .5rem;
                height: .5rem;
            }
        }
    }

    #app {
        width: 100%;
        height: 100%;
        overflow: hidden;
        /*padding: 9.2rem 0 1rem;*/
        margin: 0 auto;
        background: #fff url('./assets/img/coverBg.png') no-repeat;
        background-size: 100%;
    }


    .back {
        position: fixed;
        bottom: 3.6rem;
        right: 0.2rem;
        z-index: 90;

        img {
            width: 1.4rem;
            height: 1.4rem;
        }
    }


    .has-top .wrapper {
        box-sizing: border-box;
    }

    .top {
        position: fixed;
        width: 100%;
        left: 0;
        top: 0;
        height: 1.046699rem;
        z-index: 20;
    }


    .back-btn {
        width: .692432rem;
        height: .724638rem;
        position: absolute;
        top: .305958rem;
        left: .587762rem;
        background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm261id2iomlg5of41lp62k.png) no-repeat center top;
        background-size: 100% auto;
        z-index: 10;
    }

    .share-btn {
        width: .68438rem;
        height: .716586rem;
        position: absolute;
        top: .305958rem;
        right: .386473rem;
        background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm2717lf1elp1ff19un1b6k46.png) no-repeat center top;
        background-size: 100% auto;
        z-index: 10;
    }

    .music {
        position: fixed;
        top: 0;
        right: 1.545894rem;
        width: .716586rem;
        height: 1.1rem;
        z-index: 20;

        .music-btn {
            position: absolute;
            top: .305958rem;
            width: 100%;
            height: .764895rem;
            background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm27d0vvl96571ej71l4949.png) no-repeat center top;
            background-size: 100% 200%;

            &.off {
                background-position: center bottom;
            }
        }
    }
</style>
